import { FolderOpenDot } from 'lucide-react'
import { useState } from 'react'

import FilterManagementDropdown from 'components/brokers/needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from 'components/brokers/needs_attention/utils'
import { type MultipleSelectedValuesFilter } from 'components/brokers/types'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from 'components/reusable/table/ComboboxMultiSelectFilter'

const ReimbursementStateFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const statusOptions: ComboboxFilterOption<string>[] = [
    { label: 'Waiting For Review', value: 'waiting_for_review' },
    { label: 'Confirmed', value: 'confirmed' },
    { label: 'Processing', value: 'processing' },
    { label: 'Completed', value: 'completed' },
    { label: 'Failed', value: 'failed' },
    { label: 'Canceled', value: 'canceled' },
    { label: 'Rejected', value: 'rejected' },
    { label: 'Returned', value: 'returned' },
    { label: 'Draft', value: 'draft' },
  ]

  const filteredOptions = statusOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'State', options: filteredOptions || [] }]}
        placeholder='Search states to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={statusOptions || []}
          noSelectionText='State'
          pluralIdentifier='states'
        >
          <FolderOpenDot size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default ReimbursementStateFilter
